export default __webpack_public_path__ + "static/media/announcement_1.2996f49d.png";